import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useCustomerSubscriptions} from '../hooks/useCustomerSubscriptions.ts';

export const ReloadRecordsButton = () => {

    const {reloadRecords} = useCustomerSubscriptions();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => reloadRecords()}/>
        </Box>
    );
};

